import { gql } from './graphql';
/**
 * Files the open message's body into the deal, where it shows up in the dealroom's
 * Email tab alongside anything forwarded to the deal's upload address.
 *
 * Safe to call more than once for the same message and deal: the backend keys the
 * record on (dealID, internetMessageId), so a retry updates the existing row rather
 * than adding a duplicate.
 */
export async function uploadEmailToDeal(input) {
    const data = await gql(`mutation UploadEmailToDeal(
       $dealID: String!, $internetMessageId: String!, $senderEmail: String!, $receivedAt: String!,
       $subject: String, $bodyText: String, $bodyHtml: String,
       $toRecipients: [String!], $ccRecipients: [String!], $contractIDs: [String!]
     ) {
       uploadEmailToDeal(
         dealID: $dealID, internetMessageId: $internetMessageId, senderEmail: $senderEmail,
         receivedAt: $receivedAt, subject: $subject, bodyText: $bodyText, bodyHtml: $bodyHtml,
         toRecipients: $toRecipients, ccRecipients: $ccRecipients, contractIDs: $contractIDs
       ) { emailID }
     }`, input);
    if (!data.uploadEmailToDeal?.emailID) {
        throw new Error('Backend did not return the uploaded email');
    }
    return data.uploadEmailToDeal;
}
